module.exports = __webpack_public_path__ + "static/media/Risk Insights.bdb70505.svg";